package com.neurobs.ccab.translation

case class PhraseDataView
(
  id: Long,
  text: String,
  tags: Option[String],
  notes: Option[String],
  phraseGroupId: Long,
  phraseGroupIdentifier: String,
  phraseGroupDisplayName: String,
  index: Int,
)

case class OrderedTranslationPhraseData
(
  id: Long,
  text: String,
  tags: Option[String],
  notes: Option[String],
  index: Int,
  translationId: Option[Long],
  translationText: Option[String]
) {
  def isRepeated = tags.map(_.contains("repeated")).getOrElse(false)
}

object OrderedTranslationPhraseData {
  def empty(): OrderedTranslationPhraseData = OrderedTranslationPhraseData(-1, "", None, None, -1, None, None)
  def tupled = (OrderedTranslationPhraseData.apply _).tupled
}


case class TranslatorDataView
(
  id: Long,
  userId: Long,
  username: String,
  languageId: Long,
  languageDisplayName: String
)

case class TranslationRequestData
(
  sourceLanguage: String,
  targetLanguage: String,
  text: String,
  engineIdentifier: String = "deepl"
)

case class TranslationResponseData
(
  sourceLanguage: String,
  targetLanguage: String,
  origText: String,
  translatedText: String
)

case class CCABVersionCreateData
(
  prevProductVersionId: Long,
  newProductVersion: BigDecimal,
  productId: Long,
  ccabDiff: CCABDiffData
)

case class TranslatorProgressData
(
  translatorId: Long,
  productVersionId: Long,
  totalPhrases: Int,
  translatedPhrases: Int
)

case class ProductVersionTranslationSearchData
(
  productVersionId: Long,
  translatorId: Long,
  subPhrase: String
)






